/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Tile_SessionsInputs */

const en_us2_wrapped_tile_sessions = /** @type {(inputs: Wrapped_Tile_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`workouts this week`)
};

const pt_br2_wrapped_tile_sessions = /** @type {(inputs: Wrapped_Tile_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`treinos na semana`)
};

const es_419_wrapped_tile_sessions = /** @type {(inputs: Wrapped_Tile_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entrenamientos esta semana`)
};

const pt_pt2_wrapped_tile_sessions = /** @type {(inputs: Wrapped_Tile_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`treinos na semana`)
};

const fr_fr2_wrapped_tile_sessions = /** @type {(inputs: Wrapped_Tile_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séances cette semaine`)
};

const de_de2_wrapped_tile_sessions = /** @type {(inputs: Wrapped_Tile_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings diese Woche`)
};

const it_it2_wrapped_tile_sessions = /** @type {(inputs: Wrapped_Tile_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`allenamenti questa settimana`)
};

/**
* | output |
* | --- |
* | "workouts this week" |
*
* @param {Wrapped_Tile_SessionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_tile_sessions = /** @type {((inputs?: Wrapped_Tile_SessionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Tile_SessionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_tile_sessions(inputs)
	if (locale === "es-419") return es_419_wrapped_tile_sessions(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_tile_sessions(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_tile_sessions(inputs)
	if (locale === "de-DE") return de_de2_wrapped_tile_sessions(inputs)
	if (locale === "it-IT") return it_it2_wrapped_tile_sessions(inputs)
	return en_us2_wrapped_tile_sessions(inputs)
});
export { wrapped_tile_sessions as "wrapped.tile_sessions" }